<ng-content #cardHeader select="pxw-card-header"></ng-content>
<div
  #cardContent
  class="content"
  [ngClass]="{ 'scroll-enabled': contentScrollEnabled, 'with-padding': contentPaddingEnabled }"
>
  <ng-content></ng-content>
</div>
<ng-content #cardFooter select="pxw-card-footer"></ng-content>
